function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from 'vuex';
import _variables from '@/styles/variables.scss';
export default {
  components: {
    SidebarItem: function SidebarItem() {
      return import('./SidebarItem');
    },
    Logo: function Logo() {
      return import('./Logo');
    }
  },
  data: function data() {
    return {
      parentCur: 0,
      childcur: 0,
      isShow: false,
      activePath: '',
      menuName: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['permission_routes', 'sidebar', 'menuList', 'sidebarType', 'parentMenuId', 'defaultOpen', 'isClickTab', 'menuStatus'])), {}, {
    sidebarParentCur: {
      get: function get() {
        return this.$store.state.app.sidebarParentCur;
      },
      set: function set() {}
    },
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    isShowMenu: function isShowMenu() {
      var index = this.sidebarParentCur;
      if (index.length > 13) {
        var index_ = JSON.stringify(index);
        var indexClone = JSON.parse(index_);
        index = indexClone.slice(13);
      }
      // 二级菜单只有一个，那就用is_show==1来判断显示隐藏
      if (this.menuList && this.menuList[index] && this.menuList[index].children && this.menuList[index].children.length > 1) {
        return this.menuList[index].children.length > 0;
      } else {
        if (this.menuList && this.menuList[index] && this.menuList[index].children && this.menuList[index].children[0].is_show === 0) {
          return false;
        } else {
          return true;
        }
      }
    },
    variables: function variables() {
      return _variables;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    },
    includeRouteOrNot: function includeRouteOrNot() {
      return function (menuPath) {
        var path = this.$route.path;
        if (this.activeMenu.startsWith(menuPath)) {
          return path;
        }
        return menuPath;
      };
    }
  }),
  watch: {
    sidebarParentCur: {
      handler: function handler(nVal, oVal) {
        var nVals = nVal;
        if (nVal.length > 13) {
          nVals = nVal.slice(13);
        }
        this.isShow = true;
        if (this.isClickTab) {
          if (this.menuList[nVals].children && this.menuList[nVals].children[0].children !== undefined && this.menuList[nVals].children[0].children.length) {
            this.$store.commit('app/SET_CLICK_TAB', false);
            this.$router.push({
              path: this.menuList[nVals].children[0].children[0].menu_path
            });
          } else {
            this.$store.commit('app/SET_CLICK_TAB', false);
            this.$router.push({
              path: this.menuList[nVals].children[0].menu_path
            });
          }
        }
        this.sidebarParentCur = nVals;
      },
      deep: true
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      if (_this.sidebarParentCur >= 0) _this.isShow = true;
      _this.menuList.forEach(function (nav, i) {
        if (nav.id === _this.parentMenuId) {
          _this.parentCur = i;
        }
      });
      if (_this.menuList[_this.parentCur].children) {
        _this.$store.commit('app/SET_BARTYPE', true);
      } else {
        _this.$store.commit('app/SET_BARTYPE', false);
      }
    });
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('user', ['SET_MENU_LIST'])), {}, {
    // 父级导航点击
    handelParentClick: function handelParentClick(item, index) {
      this.parentCur = index;
      this.$store.commit('app/SETPID', item.id);
      var childUrl = '';
      var chiidLink = '';
      if (item.children) {
        if (item.children[0].children) {
          var recursiveFunction = function recursiveFunction() {
            var _getStr = function getStr(list) {
              list.children.forEach(function (row, index) {
                if (row.children) {
                  _getStr(row);
                } else {
                  if (index == 0) {
                    return chiidLink = row.menu_path;
                  }
                }
              });
            };
            _getStr(item.children[0]);
          };
          recursiveFunction();
        } else {
          chiidLink = item.children[0].menu_path;
        }
        this.childcur = 0;
        this.$router.push({
          path: chiidLink
        });
        this.$store.commit('app/SET_BARTYPE', true);
      } else {
        this.$router.push({
          path: item.menu_path
        });
        this.$store.commit('app/SET_BARTYPE', false);
      }
    },
    routerClick: function routerClick(item) {
      var _this2 = this;
      if (item.children) {
        item.children.forEach(function (el) {
          if (el.top_position && el.top_position.length > 0) {
            if (_this2.activePath == el.menu_path) {
              _this2.$store.commit('app/SETPID', el.pid);
            }
          }
        });
      } else {
        this.$store.commit('app/SETPID', item.pid);
      }
    },
    selectMenu: function selectMenu(index) {
      this.activePath = index;
    },
    clickOutside: function clickOutside() {
      if (this.isCollapse) {
        this.$store.dispatch('app/openSideBar');
      } else {
        this.$store.dispatch('app/closeSideBar', {
          withoutAnimation: false
        });
      }
    }
  })
};